import React, { useEffect, useState } from 'react';
import { NAV_LINKS, TICKER_ITEMS } from './salesData';

/**
 * Franja superior con movimiento continuo + navegación sticky mínima.
 * Sin CTA en la barra: en mobile cada píxel de altura va al hero.
 */
export function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const ticker = [...TICKER_ITEMS, ...TICKER_ITEMS, ...TICKER_ITEMS, ...TICKER_ITEMS];
  return <>
      <div className="overflow-hidden bg-charcoal" aria-hidden data-id="element-245" data-mp="29ug0b7uuicp8">
        <div className="animate-ticker flex w-max items-center py-1.5 sm:py-2" data-id="element-246" data-mp="25u5vhyishsby">
          {ticker.map((item, index) => <span key={`${item}-${index}`} className="flex shrink-0 items-center whitespace-nowrap font-sans text-[0.58rem] font-bold uppercase tracking-[0.18em] text-white sm:text-[0.64rem]" data-id="element-247" data-mp="3la4ou3nqzjs5" data-mpi={index}>
              {item}
              <span className="mx-4 text-white/50 sm:mx-6" aria-hidden data-id="element-248" data-mp="1byd5ve5f5pzw">
                ✳
              </span>
            </span>)}
        </div>
      </div>

      <header className={`sticky top-0 z-30 border-b transition-colors duration-200 ease-out ${scrolled ? 'border-warm bg-ivory/95 backdrop-blur' : 'border-transparent bg-ivory'}`} data-id="element-249" data-mp="1kwp6m9002462">
        <div className="mx-auto flex w-full max-w-6xl items-center justify-between gap-4 px-5 py-2 sm:px-8 sm:py-3" data-id="element-250" data-mp="t612co314io6">
          <a href="#top" className="flex items-baseline gap-2 leading-none" data-id="element-251" data-mp="x6kz3qjoxk9s">
            
            <span className="hidden font-sans text-[0.47rem] font-semibold uppercase tracking-[0.18em] text-charcoal/45 sm:inline sm:text-[0.56rem]" data-id="element-252" data-mp="1267fg8utfgmt">
              Aprendé a prepararlas y a ofrecerlas
            </span>
          </a>

          <nav aria-label="Secciones" className="hidden items-center gap-7 lg:flex" data-id="element-253" data-mp="9h8ul3zb60dt">
            {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="font-sans text-[0.78rem] font-semibold text-charcoal/60 transition-colors duration-200 ease-out hover:text-gold-deep" data-id="element-254" data-mp="ef22c1g9f2g7">
                {link.label}
              </a>)}
          </nav>
        </div>
      </header>
    </>;
}